import { FC } from 'react';
import styles from './index.module.less';

const Statistic: FC<{ label: string; value: string | number | null; hint?: string; icon: string }> = ({ label, value, hint, icon }) => <div className={styles.statistic}>
  <img src={icon} alt='' className={styles.statisticIcon} />
  <div className={styles.statisticContent}>
    <div className={styles.statisticValue}><strong>{value ?? '-'}</strong>{hint && <span>{hint}</span>}</div>
    <div className={styles.statisticLabel}>{label}</div>
  </div>
</div>;

export default Statistic;
